import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { PendingNote } from '../components/ui/PendingNote';
import { sceneImages } from '../data/images';
const principles = [{
  title: 'Optics',
  body: 'Thirteen 5050 LED lenses in the manufacturer’s original arrangement behind a textured front surface, for an even, diffused wash of color.'
}, {
  title: 'Enclosure',
  body: 'A white ABS circular housing, 3.3 in across and 1.2 in thick. ABS does not rust like exposed ferrous metal.'
}, {
  title: 'Power',
  body: 'An internal 3000 mAh rechargeable battery at 5 V / 3 W, charged by USB-C behind a blue protective cover.'
}, {
  title: 'Mounting',
  body: 'A matched-diameter magnetic base that stays installed while the light lifts off for charging.'
}];
const process = [{
  phase: 'Specification',
  body: 'Define the lighting system around homeowner installation, not electrician installation.'
}, {
  phase: 'Supplier validation',
  body: 'Confirm advertised performance — IP rating, run time, color options — before publication.'
}, {
  phase: 'Quality inspection',
  body: 'Individual inspection and functionality testing before shipment is planned. The program will be described here once it is operational and documented.',
  pending: true
}, {
  phase: 'Field feedback',
  body: 'Warranty and support data feed the next generation.'
}];
export function Engineering() {
  return <>
      <PageHeader image={sceneImages.waterTexture} title={<>
            Professional-Grade <span className="text-ice" data-id="element-1025" data-mp="1r0v3e5fadnse">Engineering.</span>
          </>} lead="Engineered for a brighter tomorrow. How the M1 PRO is designed around the realities of water, weather and the homeowners who use it — professional quality with effortless installation." data-id="element-1024" data-mp="20sio7nhc86kw" />

      <section className="mx-auto max-w-site px-5 py-20 md:px-8 md:py-28" data-id="element-1026" data-mp="2jj0hbt63146s">
        <h2 className="font-display text-4xl font-semibold uppercase md:text-5xl" data-id="element-1027" data-mp="2ep4kwv5gvpdq">Design principles</h2>
        <dl className="mt-12 grid gap-x-16 gap-y-12 md:grid-cols-2" data-id="element-1028" data-mp="ctoxzwglgxt7">
          {principles.map(p => <div key={p.title} className="border-t mf-hairline pt-6" data-id="element-1029" data-mp="hu2wamse8te1">
              <dt className="font-display text-3xl font-semibold uppercase" data-id="element-1030" data-mp="32auzepfpfvb">{p.title}</dt>
              <dd className="mt-3 max-w-lg text-titanium" data-id="element-1031" data-mp="815cmdbo0ydu">{p.body}</dd>
            </div>)}
        </dl>
        <p className="mt-10 text-sm text-titanium/70" data-id="element-1032" data-mp="3q68jo3l6zkgw">
          Electrical and battery figures are manufacturer-advertised.
        </p>
      </section>

      <section aria-labelledby="process-title" className="border-y mf-hairline bg-navy" data-id="element-1033" data-mp="3g9vt3eky1mqd">
        <div className="mx-auto max-w-site px-5 py-20 md:px-8 md:py-28" data-id="element-1034" data-mp="3l8p7rabyvjs4">
          <h2 id="process-title" className="font-display text-4xl font-semibold uppercase md:text-5xl" data-id="element-1035" data-mp="3lat85ianq0nn">
            Development process
          </h2>
          <ol className="relative mt-12 space-y-10 border-l border-titanium/20 pl-8" data-id="element-1036" data-mp="1jhlu0c6s5p3c">
            {process.map((p, i) => <li key={p.phase} className="relative" data-id="element-1037" data-mp="34061zp1l3g95" data-mpi={i}>
                <span className="absolute -left-[45px] flex h-7 w-7 items-center justify-center rounded-full border border-marine bg-navy text-xs font-semibold text-marine" data-id="element-1038" data-mp="2z0jsnqovmk5m">
                  {i + 1}
                </span>
                <h3 className="font-display text-2xl font-semibold uppercase" data-id="element-1039" data-mp="38y7pqn9yg3qy">
                  {p.phase}
                  {p.pending && <PendingNote data-id="element-1040" data-mp="3mob28mj18j37">Owner to define</PendingNote>}
                </h3>
                <p className="mt-1.5 max-w-xl text-titanium" data-id="element-1041" data-mp="3hprh2oc9jbbw">{p.body}</p>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="mx-auto max-w-site px-5 py-20 md:px-8" data-id="element-1042" data-mp="gbjlpidv15p">
        <PendingNote tone="block" data-id="element-1043" data-mp="3rpibkq0tpqbz">
          No certifications, laboratory test results, depth ratings, temperature ranges or brightness measurements are
          claimed. These will be published only once substantiated.
        </PendingNote>
      </section>
    </>;
}